

import { DataGrid } from "components/DataGrid/DataGrid";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";

import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { downloadCSV, getPageSize, trans } from "utils/helpers";
import { deleteMeeting, getMeeting } from "./api";
import { MeetingTabForm } from "./MeetingTabForm";


interface Form {
    Title: string,
    Status: number
}
export const Meeting = ({ }: Form) => {

    const [response, setResponse] = useState<Response | any>(null);
    const [selectedObj, setSelectedObj] = useState<any>(null);
    const [mode, setMode] = useState("create");
    const [forceUpdate, setForceUpdate] = useState(false);
    const [resetForm, setResetForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [catchMessage, setCatchMessage] = useState<any>({type:"info",msg:"NoDataForPreview"});
    const [orderBy, setOrderBy] = useState<any>([]);
    const [search, setSearch] = useState(null);
    const [showMeetingForm , setShowMeetingForm] = useState(false)
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [pages, setPages] = useState<number>(0);
    const [filterlist, setFilterlist] = useState<any>("");

    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "excel":downloadCSV(response?.Data ,1 ,trans("Meeting"));break;
            case "refresh": setForceUpdate(!forceUpdate); break;
            case "create": handleCreateAction(); break;
            case "view": if (selectedObj?.Id) handleViewRow(); break;
            case "help": alert("call api help"); break;
        }
    };

    const handleChangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize("Meeting" ,e.currentTarget.value )
        getMeetingAsync(1)
      };

    const handleGoPage = (value) => {
      if (value) {
        if (value < 1 || value > pages) { }
        else setPageNum(+value);getMeetingAsync(+value);
              } else {

      }
    };
    const handleNextPage = () => {
        if(pageNum < pages){
            setPageNum(pageNum + 1);
            getMeetingAsync(pageNum + 1);
          };
        };
    const handlePrevPage = () => {
        if(pageNum > 1){
            setPageNum((pageNum)=>{return +pageNum - 1});
            getMeetingAsync(pageNum - 1);
          };
          };
    const handleCreateAction = () => {
        setMode("create")
        setShowMeetingForm(true)
    }
    const handleEditRow = () => {
        setMode("edit");
        setShowMeetingForm(true)
       
    }
    const handleDeleteRow =async () => {
        try {
            await deleteMeeting(selectedObj.Id)
            setForceUpdate(!forceUpdate)
        } catch (error) {
            
        }

    }
    const handleViewRow = () => {
        setMode("view")
        setShowMeetingForm(true)
      
    }

    const selectedObjCallback = (obj, index) => {
        setSelectedObj(obj);
    }
    const SearchHandler = (str) => {
        setPageNum(1);
        if(str =="" ){
            setSearch(null)
        }else{
            setSearch(str)
        }
      }

    async function getMeetingAsync(PageNum = pageNum) {
        setLoading(false)
        setResponse(null)
        let pageSizeChangedByUser = getPageSize("Meeting" )
        setPageSize(pageSizeChangedByUser)
        try {

            const res = await getMeeting(PageNum,  pageSizeChangedByUser,search ,orderBy.length == 0 ?null:  orderBy.join(",") ,filterlist);
            setResponse(res.Data);
            setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) ;
            setCatchMessage({type:"info",msg:"NoDataForPreview"})
        } catch (error:any) {
            setCatchMessage({type:"error" , msg:error?.response?.data?.Message})
        }
        setLoading(true)
    }

    useEffect(() => {
        getMeetingAsync();
    }, [forceUpdate,search,orderBy,filterlist]);

    useEffect(() => {
        if (resetForm) {
            setResetForm(false);
            getMeetingAsync();
        }
    }, [resetForm]);


    return (
        <>   
         {showMeetingForm ?<ModalForm modalHeight={49} mode={mode} onHide={()=>{setShowMeetingForm(false)}} show={showMeetingForm} title={"MeetingForm" } ><MeetingTabForm onHide={()=>{setShowMeetingForm(!showMeetingForm)}} step={1} mode={mode} reload={()=>{setResetForm(true)}}   selectedObj={mode == "create" ? null : selectedObj}  showForm={()=>{setShowMeetingForm(false)}} /> </ModalForm>  : null}
            <div className="cartable-action">
                <Toolbar remove={false} handleSearch={SearchHandler} id={selectedObj?.Id} emptyList={response?.TotalRecords == 0} create={false} edit={false} search={true} handleClickToolbar={clickToolbarCallback} />
                <div className="card" style={{overflowY: "auto",
             height: "74vh",
            scrollbarWidth: "thin",}}>
                    <div className="">
                        {loading ?
                            <>
                                {
                                    response?.Data?.length > 0 ?
                                        <>
                                            <DataGrid
                                                parentName={"Meeting"}
                                                handlefiltering={(str)=>{setFilterlist(str)  }}
                                                filterStr={filterlist}
                                                orderFormat={setOrderBy}
                                                orderFormatList={orderBy}
                                                startIndex={1}
                                                theadData={Object.keys(response.Data[0])}
                                                tbodyData={response.Data}
                                                minCellWidth={80}
                                                selectedRowObjectCallback={selectedObjCallback}
                                                handleView={handleViewRow}
                                                totalRecords={response.TotalRecords}
                                                pageNum={pageNum}
                                                pageSize={pageSize}
                                                HandleNextPage={handleNextPage}
                                                HandlePrevPage={handlePrevPage}
                                                handlechangePageSize={handleChangePageSize}
                                                first={() =>{getMeetingAsync(pages); setPageNum(pages)}}
                                                end={() =>{getMeetingAsync(1); setPageNum(1)}}
                                                handleGoPage={handleGoPage}
                                            />
                                        </>
                                : <Message message={catchMessage.msg} type={catchMessage.type} />
                            }
                            </>
                            : <Loading />
                        }
                    </div>
                </div>
            </div>
        </>

    );
}